import { usePathname } from "next/navigation";
import { useEffect } from "react";

const useSetBackgorund = () => {
    const path = usePathname();

    useEffect(() => {
        const elements = document.querySelectorAll("[data-bg-src]");

        if (elements.length > 0) {
            elements.forEach((element) => {
                const src = element.getAttribute("data-bg-src");
                const htmlElement = element as HTMLElement;
                
                // Check if element has gradient class
                const hasGradient = htmlElement.classList.contains('bg-color-gradient');
                
                if (hasGradient) {
                    // If gradient is present, layer the background image behind the gradient
                    htmlElement.style.background = `
                        linear-gradient(63deg, rgba(255, 212, 163, 0.18) 17.08%, rgba(255, 255, 255, 0.18) 83.17%),
                        url(${src})
                    `;
                    htmlElement.style.backgroundRepeat = 'no-repeat';
                    htmlElement.style.backgroundPositionX = 'right';
                    htmlElement.style.backgroundSize = 'cover';
                } else {
                    // Normal background image handling
                    htmlElement.style.backgroundImage = `url(${src})`;
                }
                
                element.removeAttribute("data-bg-src");
                element.classList.add("background-image");
            });
        }
    }, [path]);
};

export default useSetBackgorund;
